import { Column, Columns, Spinner } from '@dixa/lib-shared-habla';
import { useRef } from 'react';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Slate } from 'slate-react';

import { Body } from './body';
import { useEditor } from './components/richText/hooks/useEditor';
import { Header } from './header';
import { useBulletinEditor } from './hooks/useBulletinEditor';
import styles from './styles.module.scss';

type PathParams = { messengerId: string; bulletinId: string };

/** The bulletin board editor page */
export function BulletinEditor(): JSX.Element {
  const { messengerId, bulletinId } = useParams() as PathParams;

  const editor = useEditor();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleOpenFileBrowser = () => {
    const { current } = fileInputRef;
    if (current) current.click();
  };

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileInput = e.target;
    if (fileInput instanceof HTMLInputElement) {
      editor.uploadImages(fileInput.files);
      fileInput.value = '';
    }
  };

  const {
    content,
    discardChanges,
    goBackToMessengerSettings,
    hasChanges,
    hasLoadError,
    initialTitle,
    isActive,
    isFetching,
    isUpdating,
    saveChanges,
    setContent,
    setTitle,
    setViewMode,
    title,
    viewMode,
  } = useBulletinEditor({
    messengerId,
    bulletinId,
    editor,
  });

  return (
    <Slate editor={editor} value={content} onChange={setContent}>
      <Columns>
        <Column>
          <Column.Row>
            <Header
              title={title}
              isUpdating={isUpdating}
              hasChanges={hasChanges}
              isActive={isActive}
              goBackToMessengerSettings={goBackToMessengerSettings}
              viewMode={viewMode}
              discardChanges={discardChanges}
              onSaveChanges={saveChanges}
              openFileBrowser={handleOpenFileBrowser}
            />
          </Column.Row>

          <Column.Row size={1} className={styles.body}>
            {isFetching || hasLoadError ? (
              <Spinner className={styles.spinner} />
            ) : (
              <Body
                title={viewMode === 'editor' ? title : initialTitle}
                setTitle={setTitle}
                isActive={isActive}
                hasChanges={hasChanges}
                setViewMode={setViewMode}
                viewMode={viewMode}
                fileInputRef={fileInputRef}
                fileInputOnChange={handleFileSelect}
              />
            )}
          </Column.Row>
        </Column>
      </Columns>
    </Slate>
  );
}
